var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafficLights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2H2.707C2.3026 2.00009 1.93807 2.24373 1.78332 2.61735C1.62858 2.99096 1.71409 3.42101 2 3.707L5.074 6.78C5.14599 6.85137 5.25394 6.8722 5.34732 6.83275C5.44069 6.79329 5.501 6.70136 5.5 6.6V2.25C5.5 2.11193 5.38807 2 5.25 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9H2.707C2.3026 9.00009 1.93807 9.24373 1.78332 9.61735C1.62858 9.99096 1.71409 10.421 2 10.707L5.074 13.78C5.14599 13.8514 5.25394 13.8722 5.34732 13.8327C5.44069 13.7933 5.501 13.7014 5.5 13.6V9.25C5.5 9.11193 5.38807 9 5.25 9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16H2.707C2.3026 16.0001 1.93807 16.2437 1.78332 16.6173C1.62858 16.991 1.71409 17.421 2 17.707L5.074 20.78C5.14599 20.8514 5.25394 20.8722 5.34732 20.8327C5.44069 20.7933 5.501 20.7014 5.5 20.6V16.25C5.5 16.1119 5.38807 16 5.25 16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.655 6.834C18.7482 6.87311 18.8558 6.85175 18.927 6.78L22 3.707C22.2859 3.42101 22.3714 2.99096 22.2167 2.61735C22.0619 2.24373 21.6974 2.00009 21.293 2H18.75C18.6119 2 18.5 2.11193 18.5 2.25V6.6C18.4983 6.70255 18.5599 6.79555 18.655 6.834Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.293 9H18.75C18.6119 9 18.5 9.11193 18.5 9.25V13.6C18.4998 13.7013 18.5607 13.7926 18.6543 13.8314C18.7478 13.8702 18.8555 13.8487 18.927 13.777L22 10.707C22.2859 10.421 22.3714 9.99096 22.2167 9.61735C22.0619 9.24373 21.6974 9.00009 21.293 9Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.293 16H18.75C18.6119 16 18.5 16.1119 18.5 16.25V20.6C18.4998 20.7013 18.5607 20.7926 18.6543 20.8314C18.7478 20.8702 18.8555 20.8487 18.927 20.777L22 17.707C22.2859 17.421 22.3714 16.991 22.2167 16.6173C22.0619 16.2437 21.6974 16.0001 21.293 16Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0H15.5C16.6046 0 17.5 0.895508 17.5 2V22C17.5 23.1045 16.6046 24 15.5 24H8.5C7.39543 24 6.5 23.1045 6.5 22V2C6.5 0.895508 7.39543 0 8.5 0ZM9.5 19.5C9.5 20.8806 10.6193 22 12 22C13.3807 22 14.5 20.8806 14.5 19.5C14.5 18.1194 13.3807 17 12 17C10.6193 17 9.5 18.1194 9.5 19.5ZM12 14.75C10.6193 14.75 9.5 13.6306 9.5 12.25C9.5 10.8694 10.6193 9.75 12 9.75C13.3807 9.75 14.5 10.8694 14.5 12.25C14.5 13.6306 13.3807 14.75 12 14.75ZM9.5 5C9.5 6.38062 10.6193 7.5 12 7.5C12.663 7.5 13.2989 7.23657 13.7678 6.76782C14.2366 6.29883 14.5 5.66309 14.5 5C14.5 3.61938 13.3807 2.5 12 2.5C10.6193 2.5 9.5 3.61938 9.5 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficLights);
export default __webpack_public_path__ + "static/media/trafficLights.dda3e78c.svg";
export { ForwardRef as ReactComponent };